import { CancelTokenSource } from 'axios';
import { PaginatedNext, ThirdpartySoftware } from '../types';
import { ApiRepository } from './main repository/api.repository';
import { PaginateOptions } from './type';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ThirdpartySoftwareService {
  const BASE_API = `${window.globalConfiguration.api.base}/v1/software-on-laptop`;

  export const get = async ({
    page,
    limit,
    filters,
    sorting,
    search,
    cancelTokenSource,
  }: PaginateOptions): Promise<PaginatedNext<ThirdpartySoftware>> => {
    return ApiRepository.Core().get<PaginatedNext<ThirdpartySoftware>>(
      `${BASE_API}/paginated?page=${page}&limit=${limit}${filters.join('')}${sorting}`,
      {
        ...(search && { search: search }),
      },
      { ...(cancelTokenSource && { cancelToken: cancelTokenSource.token }) }
    );
  };

  export const exportExcel = async ({
    filters,
    sorting,
    search,
  }: {
    filters: string[];
    sorting: string;
    search?: string;
    cancelTokenSource?: CancelTokenSource;
  }): Promise<Buffer> => {
    return ApiRepository.Core().get(
      `${BASE_API}/export?${filters.join('')}${sorting}`,
      {
        ...(search && { search: search }),
      },
      { responseType: 'blob' }
    );
  };
}
